import React, {  useState } from "react";
import { SidePopup } from "../../components/model-popup/side-popup";
import { CustomButton } from "../../components/buttons/button";
import { useFormik } from "formik";
import * as yup from "yup";
import TextIconInput from "../../components/custom-fields/input";
import SelectInput from '../../components/custom-fields/select'
import ErrorMessage from "../../components/custom-fields/error-message";
import { alphabetValidate, spaceValidate,phoneNumberValidate } from "../../utils/field-validation";
import { UsersPostAPI } from "../../api/create";
import { UsersPutAPI } from "../../api/update";
import {toast} from "react-toastify";
import { useSelector } from "react-redux";

export const UsersPopup = (props: any) => {
    const {
        viewPopup,
        showModal,
        setShowModal,
        title,
        setTitle,
        handleClose,
        fetchAPI,
        poupDetails,
        setPoupDetails,
        setDecrypt,
        roleList
    } = props;

    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [, setOpen] = useState<any>(null);
    const [, setShowPassword] = useState<boolean>(false);
    const [, setViewOnly] = useState<any>(false);
    const UserAccess = useSelector(
        (state: any) => state?.rolesAccess?.roleAccess || {}
    );
   
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: poupDetails?.first_name || "",
            last_name: poupDetails?.last_name || "",
            email: poupDetails?.email || "",
            phone_number: poupDetails?.phone_number || "",
            role_id:poupDetails?.role_id || "",
        },

        validationSchema: yup.object({
            first_name: yup.string().required("First Name is required"),
            last_name: yup.string().required("Last Name is required"),
            email: yup
                .string()
                .email()
                .required("Email is required")
                .test("is-lowercase", "Email must be in lowercase", (value) => {
                    return value === value.toLowerCase();
                }),
            phone_number: yup
                .string()
                .min(10, "Phone Number must have atleast 10 Charaters"),
            role_id: yup.string().required("Role is required"),
        }),
        onSubmit: async (values: any) => {
            setButtonLoader(true);
            const data = {
                ...values,

            }
            data.phone_number=String(data.phone_number)
            const handleUploadAPI = async (method: string) => {
                if (method === "put") {
                      await UsersPutAPI(poupDetails?.id, {
                        ...data
                      })
                        .then(async (res: any) => {
                          if (res?.result) {
                            toast.success(res?.message || "user updated success");
                            fetchAPI(true);
                            if (viewPopup) {
                              setPoupDetails(res?.result);
                              setTitle("Admin User Details");
                            } else {
                              setShowModal(false);
                              setPoupDetails({});
                            }
                            formik?.resetForm();
                          } else {
                            toast.error(res?.message || "User update failed");
                          }
                        })
                        .catch((err: any) => {
                          console.error(err);
                        });
                } else if (method === "post") {
                      await UsersPostAPI({
                        ...data,
                      })
                        .then(async (res: any) => {
                          if (res?.result) {
                            toast.success(res?.message || "User created success");
                            fetchAPI(true);
                            setShowModal(false);
                            setDecrypt("");
                            formik?.resetForm();
                          } else {
                              toast.error(res?.detail?.message || res?.message || "User creation failed");
                          }
                        })
                        .catch((err: any) => {
                          console.error(err);
                        });
                }
                setButtonLoader(false);
            };

            await handleUploadAPI(title === "Edit User" ? "put" : "post");
        },
    });
    async function handleErrorFields() {
        await formik.validateForm();
        if (formik?.errors) {
            const errorField: any = Object.keys(formik.errors)?.[0];
            document.getElementById(errorField)?.focus();
            document.getElementById(errorField)?.scrollIntoView({
                block: "center",
                inline: "end",
                behavior: "smooth",
            });
        }
    }

    return (
        //eslint-disable-next-line
        //@ts-ignore
        <SidePopup
            showModal={showModal}
            handleClose={handleClose}
            title={title}
            clearFormik={() => formik.resetForm()}
            closeIcon={false}
            topButton={
                title === "Admin User Details" &&
                UserAccess?.roleAccess?.users?.update && (
                    <CustomButton
                        primary={true}
                        buttonStyle="text-white px-[22px] py-[12px] leading-[19px] text-[14px] font-semibold"
                        buttonName="Edit"
                        onClick={() => setTitle("Edit User")}
                    />
                )
            }
            footerStyle="flex justify-end gap-[16px] "
            footerContent={
                title !== "Admin User Details" ? (
                    <>
                        <CustomButton
                            buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
                            buttonName="Cancel"
                            primary={false}
                            disable={buttonLoader}
                            onClick={() => {
                                if (viewPopup) {
                                    setTitle("Admin User Details");
                                } else {
                                    setShowModal(false);
                                    setPoupDetails({});
                                    setDecrypt("");
                                    setViewOnly(false);
                                    setShowPassword(false);
                                }
                                formik.resetForm();
                            }}
                        />
                        <CustomButton
                            type="submit"
                            loader={buttonLoader}
                            loaderStyle={` ${title === "Edit User" ? "px-[52px]" : "px-[40.5px]"
                                } py-[13px] leading-[17px]`}
                            primary={true}
                            disable={buttonLoader}
                            buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
                            buttonName={title === "Edit User" ? "Update" : "Add"}
                            onClick={() => {
                                handleErrorFields();
                                formik.handleSubmit();
                            }}
                        />
                    </>
                ) : (
                    false
                )
            }
        >
            {title === "Admin User Details" ? (
                <div>
                    <div className="my-[12px]">
                        <div className="w-full pb-4">
                            <h3 className="text-[14px] text-[#68717D] font-normal pb-1">
                                First Name
                            </h3>
                            <p className="text-[16px] text-[#1C2A3D] font-medium">
                                {poupDetails?.first_name}
                            </p>
                        </div>
                        <div className="w-full pb-4">
                            <h3 className="text-[14px] text-[#68717D] font-normal pb-1">
                                Last Name
                            </h3>
                            <p className="text-[16px] text-[#1C2A3D] font-medium">
                                {poupDetails?.last_name}
                            </p>
                        </div>
                        <div className="w-full">
                            <h3 className="text-[14px] text-[#68717D] font-normal pb-1">
                                Email
                            </h3>
                            <div className="text-[16px] text-[#1C2A3D] font-medium max-w-[300px] truncate">
                                {poupDetails?.email}
                            </div>
                        </div>
                        <div className="w-full">
                            <h3 className="text-[14px] text-[#68717D] font-normal pb-1">
                                Password
                            </h3>
                            <div className="text-[16px] text-[#1C2A3D] font-medium max-w-[300px] truncate">
                                {poupDetails?.password}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                (title === "Edit User" || title === "Add New User") && (
                    <div
                        className="pt-[8px] grid grid-cols-1 gap-x-[12px]"
                        onClick={() => {
                            setOpen(null);
                        }}
                    >
                        <div className="w-full col-span-1 mb-[5px]">
                            <TextIconInput
                                label="First Name"
                                name="first_name"
                                id="first_name"
                                type="text"
                                disable={buttonLoader}
                                maxLength={30}
                                value={formik.values.first_name}
                                onChange={formik.handleChange}
                                onkeypress={alphabetValidate}
                                errors={formik.errors.first_name && formik.touched.first_name}
                                placeholder="Enter first name"
                                onBlur={formik.handleBlur}
                                required
                            />
                            {formik.errors.first_name && formik.touched.first_name ? (
                                <ErrorMessage>{formik.errors.first_name}</ErrorMessage>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>
                        <div className="w-full col-span-1 mb-[5px]">
                            <TextIconInput
                                label="Last Name"
                                name="last_name"
                                id="last_name"
                                type="text"
                                disable={buttonLoader}
                                maxLength={30}
                                value={formik.values.last_name}
                                onChange={formik.handleChange}
                                onkeypress={alphabetValidate}
                                errors={formik.errors.last_name && formik.touched.last_name}
                                placeholder="Enter last name"
                                onBlur={formik.handleBlur}
                                required
                            />
                            {formik.errors.last_name && formik.touched.last_name ? (
                                <ErrorMessage>{formik.errors.first_name}</ErrorMessage>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>
                        <div className="w-full col-span-1 mb-[5px]">
                            <TextIconInput
                                label="Email Address"
                                name="email"
                                id="email"
                                type="email"
                                value={formik.values.email}
                                maxLength={150}
                                onChange={formik.handleChange}
                                disable={buttonLoader || title === 'Edit User'}
                                onkeypress={spaceValidate}
                                errors={formik.errors.email && formik.touched.email}
                                placeholder="Enter  email"
                                onBlur={formik.handleBlur}
                                required
                            />
                            {formik.errors.email && formik.touched.email ? (
                                <ErrorMessage>{formik.errors.email}</ErrorMessage>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>

                        <div className="w-full col-span-1 mb-[5px]">
                            <SelectInput
                                divStyle="mt-[4px]"
                                label={'User Role'}
                                minLength={6}
                                placeholder="Select Role"
                                maxLength={50}
                                name="role_id"
                                id="role_id"
                                value={formik.values.role_id}
                                errors={formik.errors.role_id && formik.touched.role_id}
                                onChange={formik.handleChange}
                                disable={buttonLoader}
                                onBlur={formik.handleBlur}
                                options={roleList}
                                valueKey = {'id'}
                                labelKey = {'role_name'}
                                required
                            />
                            {formik.errors.role_id && formik.touched.role_id ? (
                                <ErrorMessage>{formik.errors.role_id}</ErrorMessage>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>

                        <div className="w-full col-span-1 mb-[5px]">
                            <TextIconInput
                                divStyle="mt-[4px]"
                                label={
                                    title === "Edit User"
                                        ? "Phone Number"
                                        : "Phone Number"
                                }
                                minLength={6}
                                placeholder="Enter phone number"
                                maxLength={50}
                                name="phone_number"
                                id="password"
                                value={formik.values.phone_number}
                                errors={formik.errors.phone_number && formik.touched.phone_number}
                                onChange={formik.handleChange}
                                disable={buttonLoader}
                                onBlur={formik.handleBlur}
                                onkeypress={phoneNumberValidate}
                            />
                            {formik.errors.phone_number && formik.touched.phone_number ? (
                                <ErrorMessage>{formik.errors.phone_number}</ErrorMessage>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </div>
                        
                    </div>
                )
            )}
        </SidePopup>
    );
};
